import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../hooks/useContent";
import { useSeo } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Section } from "../components/Primitives";
import { ImageOff } from "lucide-react";

export default function Galerie() {
  const { t, pick } = useI18n();
  useSeo(t("nav.gallery"), "Galerie photos de la Résidence Doux Instants à Laval : espaces de vie, salle à manger, jardin et chambres.");
  const { data: gallery = [] } = useContent("gallery");

  return (
    <>
      <PageHero eyebrow={t("nav.gallery")} title={t("home.galleryTitle")} />
      <Section tone="surface">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3" data-testid="gallery-grid">
          {gallery.map((g) => (
            <figure key={g.id} className="overflow-hidden rounded-2xl border border-black/5 bg-[#EEF1E9]">
              {g.image ? (
                <img src={g.image} alt={pick(g.caption)} loading="lazy"
                  className="aspect-[4/3] w-full object-cover transition-transform hover:scale-105" />
              ) : (
                <div className="flex aspect-[4/3] w-full flex-col items-center justify-center gap-2 p-4 text-center text-[#9CAF88]">
                  <ImageOff className="h-8 w-8" />
                  <span className="text-xs">{pick(g.caption)}</span>
                </div>
              )}
              <figcaption className="p-3 text-sm text-[#5C6370]">{pick(g.caption)}</figcaption>
            </figure>
          ))}
        </div>
      </Section>
    </>
  );
}
